import { createContext, useContext } from 'react';

/**
 * Chế độ chỉnh sửa tại chỗ trên trang công khai.
 *
 * Giá trị mặc định là "không được sửa", nên các thành phần công khai (AppCard,
 * AppDetail) gọi `useEditMode()` thoải mái mà không cần provider: khách vào
 * trang chỉ thấy `canEdit === false` và giao diện không đổi một chút nào.
 */
const EditModeContext = createContext({ canEdit: false, requestEdit: () => {} });

export const useEditMode = () => useContext(EditModeContext);

export default EditModeContext;
